import React from "react";
import { Row, Col, Progress, Typography, Tooltip, Space, Tag } from "antd";
import {
  ShopOutlined,
  UsbOutlined,
  CarOutlined,
  CheckCircleOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  QuestionCircleOutlined,
  RightOutlined,
} from "@ant-design/icons";

// 定义页面主组件
const PublicChargingPile = ({
  successData,
  equipmentHealthRate,
  equipmentHealthRateSequential,
  equipmentQry,
  params,
  openTab,
}) => {
  // 从 successData 中提取数据，使用默认值作为后备
  const { chargingSuccessRate, sequential = 0 } = successData || {};

  const { station: powerStationCount, stub: chargingGunCount } = equipmentQry || {};

  // 数据配置
  const dashboardData = [
    {
      title: "电站数(个)",
      value: powerStationCount,
      icon: <ShopOutlined />,
      iconBg: "#1677ff", // 蓝色
      compare: {
        value: "+15.6%",
        status: "up", // up/down
      },
      hasDetail: "station",
      span: 5,
    },
    {
      title: "充电枪数(台)",
      value: chargingGunCount,
      icon: <UsbOutlined />,
      iconBg: "#52c41a", // 绿色
      compare: {
        value: "-1.3%",
        status: "down",
      },
      hasDetail: "stub",
      span: 5,
    },
    {
      title: "设备完好率",
      value: `${equipmentHealthRate}%`,
      progress: equipmentHealthRate,
      icon: <CarOutlined />,
      iconBg: "#faad14", // 黄色
      compare: {
        value: `${equipmentHealthRateSequential}%`,
        status: equipmentHealthRateSequential >= 0 ? "up" : "down",
      },
      progressColor: "#faad14",
      span: 7,
    },
    {
      title: "充电成功率",
      value: `${chargingSuccessRate}%`,
      progress: chargingSuccessRate,
      icon: <CheckCircleOutlined />,
      iconBg: "#d3adf7", // 浅紫色
      compare: {
        value: `${sequential}%`,
        status: sequential >= 0 ? "up" : "down",
      },
      progressColor: "#d3adf7",
      span: 7,
    },
  ];

  const { Title, Text } = Typography;

  const openStationDetail = () => {
    openTab(
      {
        cityIds: params.cityIds,
        provinceIds: params.provinceIds,
        operationMode: params.operationMode,
      },
      {
        key: "0101",
        titleText: "电站列表",
      },
    );
  };

  const openStubDetail = () => {
    openTab(
      {
        cityIds: params.cityIds,
        provinceIds: params.provinceIds,
        stubType: params.stubType,
        operationMode: params.operationMode,
      },
      {
        key: "0102",
        titleText: "公充设备查询",
      },
    );
  };

  return (
    <div style={{ width: "100%", padding: "20px 0px 4px 20px", background: "#fff" }}>
      {/* 提示文本 + 标题 */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          marginBottom: "20px",
        }}>
        <Title level={4} style={{ margin: "8px 0 0 0" }}>
          公充充电桩
        </Title>
        <div style={{ paddingTop: 8 }}>
          <Tooltip title="电站、充电枪数为实时数据，不随选择日期变化">
            <QuestionCircleOutlined
              style={{ marginLeft: "8px", color: "#999", fontSize: "14px" }}
            />
          </Tooltip>
        </div>
      </div>

      {/* 数据卡片布局 */}
      <Row style={{ margin: "8px 16px 16px -8px" }}>
        {dashboardData.map((item, index) => (
          <Col span={item.span} key={index}>
            <Row>
              {/* 图标 */}
              <Col span={8} style={{ display: "flex", justifyContent: "center" }}>
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    background: item.iconBg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    // margin: "0 auto 8px",
                    color: "#fff",
                    fontSize: "28px",
                  }}>
                  {item.icon}
                </div>
              </Col>
              <Col span={16}>
                {/* 指标标题 + 详情链接 */}
                <Space align="center" style={{ fontSize: "18px", margin: "8px 0px" }}>
                  <Text type="secondary">{item.title}</Text>
                  {item.hasDetail && (
                    <div
                      style={{
                        color: "#5584FF",
                        fontSize: "12px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (item.hasDetail === "station") {
                          openStationDetail();
                        } else if (item.hasDetail === "stub") {
                          openStubDetail();
                        }
                      }}>
                      {" "}
                      详情
                      <RightOutlined />{" "}
                    </div>
                  )}
                  {typeof item.progress === "number" && (
                    <Text
                      strong
                      style={{ fontSize: "24px", display: "block", marginBottom: "8px" }}>
                      {item.value}
                    </Text>
                  )}
                </Space>

                {/* 核心数值 */}
                {typeof item.progress !== "number" && (
                  <Text strong style={{ fontSize: "24px", display: "block", marginBottom: "8px" }}>
                    {item.value}
                  </Text>
                )}
                {/* 进度条（仅完好率/成功率展示） */}
                {typeof item.progress === "number" && (
                  <Progress
                    percent={item.progress}
                    strokeColor={item.progressColor}
                    size="small"
                    style={{ marginBottom: "8px" }}
                    showInfo={false}
                  />
                )}
              </Col>
            </Row>
            {/* 同比变化 */}
            {typeof item.progress === "number" && params.isMonth !== 3 && (
              <Row>
                <Col span={8} align="center">
                  <Text type="secondary" style={{ fontSize: "12px" }}>
                    环比
                  </Text>
                </Col>
                <Col span={16}>
                  <Tag
                    icon={
                      item.compare.status === "up" ? (
                        <ArrowUpOutlined size={12} />
                      ) : (
                        <ArrowDownOutlined size={12} />
                      )
                    }
                    color={item.compare.status === "up" ? "success" : "error"}
                    size="small">
                    {item.compare.value}
                  </Tag>
                </Col>
              </Row>
            )}
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default PublicChargingPile;



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/publicChargingPile.js